<template>
  <div
    :class="{'focused-target': focused}"
  >
    <div
      v-if="hasDiscriminativeStimulus"
      class="row full-width bg-primary-variant text-white q-px-sm q-py-xs"
    >
      {{ target.discriminativeStimulus }}
    </div>
    <div class="row text-center full-width q-px-sm q-pt-sm">
      <div
        :class="{
          'text-uppercase text-dark-variant target-set-overline': tiny,
        }"
        class="text-overline row items-center"
      >
        <q-chip
          v-if="!tiny"
          size="sm"
          :text-color="getTextColor(getTargetWorkflowProperty('color', ''))"
          :color="getTargetWorkflowProperty('color', '')"
          :style="{ backgroundColor: getTargetWorkflowProperty('color', '') }"
          :icon="getTargetWorkflowProperty('icon', 'help')"
          class="chip-no-label"
        />
        {{ target.label }}
      </div>
    </div>
    <div
      :class="{'no-wrap': dense && tiny}"
      class="row q-pa-sm q-col-gutter-sm"
    >
      <span
        v-for="subTarget in sortedTargets"
        :key="subTarget.id"
      >
        <target-data
          ref="targets"
          :session-program="sessionProgram"
          :target="subTarget"
          :data="data"
          :active-prompt-levels="activePromptLevels"
          :dense="dense"
          :tiny="tiny"
          :disable="disable"
          :workflow-statuses="workflowStatuses"
          :prevent-duplicates-on-trial="preventDuplicatesOnTrial"
          :session-paused="sessionPaused"
          :session-duration-offset="sessionDurationOffset"
          @record="onRecordData"
          @record-program-data="onRecordProgramData"
        />
      </span>
    </div>
  </div>
</template>
<script>
import { chain, get } from 'lodash';
import DataCollection from 'src/mixins/DataCollection';
import { defineAsyncComponent } from 'vue';
import { getTextColor } from 'src/utils/TargetUtils';

export default {

  name: 'TargetSetTarget',

  components: { TargetData: defineAsyncComponent(() => import('components/Programs/DataCollection/TargetData')) },

  mixins: [DataCollection],

  emits: ['record-target', 'record-program-data'],

  computed: {

    sortedTargets() {
      return get(this.target, 'subTargets', []);
    }, // sortedTargets()

  },

  methods: {
    getTextColor,

    onRecordData(sessionProgram, target, data) {
      this.$emit('record-target', target, data);
    }, // onRecordData()

    onRecordProgramData(sessionProgram, dataObj) {
      this.$emit('record-program-data', sessionProgram, dataObj);
    }, // onRecordProgramData()

    finishSession() {
      return chain(this.$refs)
        .get('targets')
        .map((targetRef) => {
          if (chain(targetRef).get('finishSession').isFunction().value()) {
            return targetRef.finishSession();
          }
          return null;
        })
        .flatten()
        .compact()
        .value();
    }, // finishSession()

  },
};
</script>
<style scoped>

.target-set-overline {
  font-size: 7px;
  line-height:1rem;
}

</style>
